












import { Vue, Component } from "vue-property-decorator";
import { format, startOfToday, addDays } from "date-fns";
import locale from "date-fns/locale/de";
import {
  THEME_BTN_SECONDARY,
  THEME_BTN_TERTIARY,
  THEME_DATE_FORMAT,
  THEME_DATE_FORMAT_SHORT
} from "@/constants/theme";
import { allowedDateRange } from "@/constants/dateRange";
import { isSmallMobile } from "@/utils/responsive";
import SlcPagination from "./SlcPagination.vue";

@Component({
  components: {
    SlcPagination
  }
})
export default class SlcPaginationProvider extends Vue {
  dateSelectorButtonTheme = THEME_BTN_TERTIARY;

  /**
   * Returns the start date string from routing parameters
   */
  get startDate(): string {
    return String(this.$route.query.startDate);
  }

  /**
   * Returns the formated from date string based on the viewport width.
   */
  get dateFrom(): string {
    const dateFormat = isSmallMobile(this)
      ? THEME_DATE_FORMAT_SHORT
      : THEME_DATE_FORMAT;

    return format(this.startDate, dateFormat, {
      locale
    });
  }

  allowedDateRange = allowedDateRange;

  /**
   * Returns the array of processed menu items.
   */
  get items(): any[] {
    return [
      {
        hidden: isSmallMobile(this),
        label: this.$t("today"),
        startDate: format(startOfToday(), "YYYY-MM-DD"),
        text: this.$t("today"),
        theme: THEME_BTN_SECONDARY
      },
      {
        disabled: !allowedDateRange(addDays(this.startDate, -1)),
        hidden: isSmallMobile(this),
        icon: "navigate_before",
        label: this.$t("Previous Day"),
        startDate: format(addDays(this.startDate, -1), "YYYY-MM-DD"),
        theme: THEME_BTN_TERTIARY
      },
      {
        disabled: !allowedDateRange(addDays(this.startDate, 1)),
        hidden: isSmallMobile(this),
        icon: "navigate_next",
        label: this.$t("Next Day"),
        startDate: format(addDays(this.startDate, 1), "YYYY-MM-DD"),
        theme: THEME_BTN_TERTIARY
      }
    ];
  }

  /**
   * Pushes the start date into routing parameters
   */
  selectStartDate({ startDate }): void {
    this.$router.push({
      query: {
        ...this.$route.query,
        startDate
      }
    });
  }
}
